import * as React from 'react';
import { useContext } from 'react';

import { Text } from '@shared/components/bootstrap';
import { InventoryContext } from '@shared/components/inventory_capture/inventory_context';
import { filterInventoryForSave } from '@shared/utils/filter_inventory_for_save';

import { incompleteInventory } from './incomplete';
import { STEPS } from './steps';

const DEFAULT_INCOMPLETE_PLACEHOLDER = 'Not answered';

const ITEM_LIST_SUMMARY_CLASS_NAMES = new Set(['pickup-items', 'any-additional-items']);

export const Summary: React.FC<{
  hideMoving?: boolean;
  hidePacking?: boolean;
  hideItemLists?: boolean;
  incompletePlaceholder?: string;
}> = ({ incompletePlaceholder = DEFAULT_INCOMPLETE_PLACEHOLDER, hideMoving, hidePacking, hideItemLists }) => {
  const { data } = useContext(InventoryContext);

  const activeSteps = STEPS.filter((step) => step.isActive(data, { hideMoving, hidePacking })).filter(
    (step) => !(hideItemLists && ITEM_LIST_SUMMARY_CLASS_NAMES.has(step.className)),
  );

  const inventory = filterInventoryForSave(data);

  if (incompleteInventory(inventory)) {
    return (
      <Text tag="p" style="danger">
        {incompletePlaceholder}
      </Text>
    );
  }

  return (
    <>
      {activeSteps.map((step, index) => (
        <step.summary pickup={!hidePacking} key={index} />
      ))}
    </>
  );
};
